// 計算ボタンコンポーネント

// React 18以降はJSXの自動変換によりReactインポートは不要

interface CalculateButtonProps {
  isLoading: boolean;
  isValid: boolean;
  className?: string;
}

export function CalculateButton({
  isLoading,
  isValid,
  className = '',
}: CalculateButtonProps) {
  return (
    <button
      type="submit"
      disabled={isLoading || !isValid}
      className={`btn-primary ${className}`}
      aria-describedby={!isValid ? 'calculate-button-help' : undefined}
    >
      {isLoading ? (
        <div className="flex items-center justify-center">
          <svg 
            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <circle 
              className="opacity-25" 
              cx="12" 
              cy="12" 
              r="10" 
              stroke="currentColor" 
              strokeWidth="4"
            />
            <path 
              className="opacity-75" 
              fill="currentColor" 
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          計算中...
        </div>
      ) : (
        <div className="flex items-center justify-center">
          <svg 
            className="h-5 w-5 mr-2" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" 
            />
          </svg>
          計算実行
        </div>
      )}
      {!isValid && (
        <div id="calculate-button-help" className="mt-2 text-sm text-red-600">
          部材名を選択し、すべての必須項目を入力してください
        </div>
      )}
    </button>
  );
}